import { render, staticRenderFns } from "./TraceabilityTableHeader.vue?vue&type=template&id=4df511d8&scoped=true"
import script from "./TraceabilityTableHeader.vue?vue&type=script&lang=js"
export * from "./TraceabilityTableHeader.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityTableHeader.vue?vue&type=style&index=0&id=4df511d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df511d8",
  null
  
)

export default component.exports